import React from 'react';
import styles from './index.modules.scss';
import { Text } from '@shakkerai/pro-components';

const typeColorMap = {
  primary: styles.tagSuccess,
  primary2: styles.tagSuccess2,
  warn: styles.tagWarn,
};

export const Tag = (props) => {
  const { children, className, type = 'primary', ...rest } = props;

  const innerClassName = typeColorMap[type];

  return (
    <Text className={`${styles.base} ${innerClassName} ${className}`} size={10} fw={600} {...rest}>
      {children}
    </Text>
  );
};
